export enum Steps {
  Details = 'details',
  IdentityVerification = 'identity_verification',
  ContractSignature = 'contract_signature',
  None = 'none',
}
